import { blueprintAlertMutations } from '@cobliteam/api/blueprintAlerts';
import { useMutation } from '@tanstack/react-query';
import type { AlertHookType } from './types';

/** Creates the alert rule of a blueprint hook; a failure toasts through the query client's global handler. */
const useCreateHookAlert = (type: AlertHookType) => {
  const { mutateAsync: createHookAlert, isPending } = useMutation({
    ...blueprintAlertMutations.createHookAlert(),
    meta: { errorMessageKey: `alertHooks:${type}.confirm.error` },
  });

  return { createHookAlert, isPending };
};

export default useCreateHookAlert;
